import * as React from "react";
const SvgZz16 = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M7.111 7.111V8.89l-4.735 5.333h4.735V16H0v-1.778L4.734 8.89H0V7.11zM16 0v1.778L11.265 7.11H16V8.89H8.889V7.11l4.734-5.333H8.89V0z" /></svg>;
export default SvgZz16;